const SDK_VERSION = '8.36.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
